import {
  THINGYAN_MISSIONS,
  THINGYAN_OPEN_POPUP_HISTORY,
  THINGYAN_CONFIG_EVENT,
  THINGYAN_CHANGE_ATTEMPT_BY_BID,
  THINGYAN_SET_SPIN,
  THINGYAN_AWARD_LIST,
  THINGYAN_PRIZE_COLLECTION,
  THINGYAN_OPEN_POPUP_ADD_SPIN,
  THINGYAN_OPEN_POPUP_ADD_SPIN_SUPER,
  THINGYAN_TAKE_PRIZE,
  THINGYAN_WINNER_LIST,
  THINGYAN_DATA_HISTORY,
  THINGYAN_OPEN_POPUP_ERROR,
} from "./contants";

const initState = {
  configEventThingyan: [],
  dataMission: [],
  dataChangeAttempt: [],
  dataSpinLeft: [],
  dataAwardList: [],
  dataPrizeCollection: [],
  isOpenPopupHistory: false,
  dataTakePrize: [],
  dataWinnerList: [],
  dataHistory: {},
  dataPopupError: {},

  dataPopupAddSpin: {
    isOpenPopupAddSpin: false,
    totalAdd: 0,
    content: "",
  },
  dataPopupAddSpinSuper: {
    isOpen: false,
    totalSmail: 0,
    totalSuper: 0,
    contentHeader: "",
    content: "",
  },
};

const reducerEventThingYan = (state = initState, actions) => {
  switch (actions.type) {
    case THINGYAN_WINNER_LIST:
      return {
        ...state,
        dataWinnerList: actions.payload.data,
      };
    case THINGYAN_TAKE_PRIZE:
      return {
        ...state,
        dataTakePrize: actions.payload.data,
      };
    case THINGYAN_CONFIG_EVENT:
      return {
        ...state,
        configEventThingyan: actions.payload.data,
      };
    case THINGYAN_MISSIONS:
      return {
        ...state,
        dataMission: actions.payload.data,
      };
    case THINGYAN_CHANGE_ATTEMPT_BY_BID:
      return {
        ...state,
        dataChangeAttempt: actions.payload.data,
      };
    case THINGYAN_SET_SPIN:
      return {
        ...state,
        dataSpinLeft: actions.data,
      };
    case THINGYAN_AWARD_LIST:
      return {
        ...state,
        dataAwardList: actions.payload.data,
      };

    case THINGYAN_PRIZE_COLLECTION:
      return {
        ...state,
        dataPrizeCollection: actions.payload.data,
      };
    case THINGYAN_OPEN_POPUP_HISTORY:
      return {
        ...state,
        isOpenPopupHistory: actions.data,
      };
    case THINGYAN_OPEN_POPUP_ADD_SPIN:
      return {
        ...state,
        dataPopupAddSpin: actions.data,
      };
    case THINGYAN_OPEN_POPUP_ADD_SPIN_SUPER:
      return {
        ...state,
        dataPopupAddSpinSuper: actions.data,
      };
      case THINGYAN_DATA_HISTORY:
        return {
          ...state,
          dataHistory: actions.data,
        };
      case THINGYAN_OPEN_POPUP_ERROR:
        return {
          ...state,
          dataPopupError: actions.data
        }
    default:
      return state;
  }
};

export default reducerEventThingYan;
